import { useLocation, useNavigate } from 'react-router';
import { useEffect } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Home, ArrowLeft, Search, HelpCircle, Shield, Briefcase } from "lucide-react";
import { usePageMeta } from "@/hooks/usePageMeta";

const quickLinks = [
  { label: "Find Services", icon: Search, href: "/booking-flow" },
  { label: "Safety Guide", icon: Shield, href: "/safety" },
  { label: "How It Works", icon: HelpCircle, href: "/how-it-works" },
  { label: "Become a Helper", icon: Briefcase, href: "/become-helper" },
];

const NotFound = () => {
  usePageMeta("Page Not Found | Kanfy");
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
        <div className="min-h-dvh bg-background flex flex-col pb-[max(1rem,env(safe-area-inset-bottom,1rem))]">
      <Header />

      <main id="main-content" className="flex-1 flex items-center justify-center py-20 px-4">
        <div className="text-center max-w-lg mx-auto">
          {/* Illustration */}
          <div className="relative inline-flex items-center justify-center mb-8">
            <div className="w-32 h-32 rounded-full bg-primary/10 flex items-center justify-center">
              <span className="text-6xl font-extrabold text-primary leading-none">404</span>
            </div>
          </div>

          <h1 className="h-page text-foreground mb-3">
            Page not found
          </h1>
          <p className="text-muted-foreground mb-8 max-w-sm mx-auto leading-relaxed">
            We couldn't find <span className="font-mono text-sm bg-muted px-1.5 py-0.5 rounded">{location.pathname}</span>. It may have been moved, deleted, or you may have mistyped the URL.
          </p>

          {/* Primary actions */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center mb-10">
            <Button size="lg" onClick={() => navigate(-1)} variant="outline">
              <ArrowLeft className="h-4 w-4 mr-2" />
              Go Back
            </Button>
            <Button size="lg" onClick={() => navigate("/")}>
              <Home className="h-4 w-4 mr-2" />
              Return Home
            </Button>
          </div>

          {/* Quick links */}
          <div>
            <p className="text-sm text-muted-foreground mb-3 font-medium">Or jump to a popular page:</p>
            <div className="grid grid-cols-2 gap-2 max-w-xs mx-auto">
              {quickLinks.map(({ label, icon: Icon, href }) => (
                <button
                  key={href}
                  onClick={() => navigate(href)}
                  className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted transition-colors text-left"
                >
                  <Icon className="h-4 w-4 shrink-0" aria-hidden="true" />
                  {label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default NotFound;
